<form #invoiceForm="ngForm" class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/proforma']">Proforma</a> > {{ invoice.invoice_no }}</h3>
    </div>
    <div class="form-actions">
      <a *ngIf="invoice.id && isFormDisabled && !['cancelled'].includes(invoice.status)" target="_blank" href="/api/invoice/{{ invoice.id }}/download">
        <button type="button" mat-stroked-button><mat-icon>print</mat-icon> Print</button>
      </a>
      <ng-container *ngIf="!['submitted','cancelled'].includes(invoice.status)">
        <button *ngIf="isFormDisabled && invoice.status == 'draft'" type="button" mat-flat-button color="primary" (click)="confirmDialog()">
          <mat-icon>receipt_long</mat-icon> Generate Invoice
        </button>
        <button *ngIf="!isFormDisabled" [disabled]="onSaveDisable" type="submit" mat-flat-button color="primary" (click)="save(invoiceForm.valid)">
          <mat-icon>save</mat-icon> Save
        </button>
        <button *ngIf="isFormDisabled" type="button" mat-stroked-button (click)="edit()">
          <mat-icon>edit</mat-icon> Edit
        </button>
        <button *ngIf="isFormDisabled && invoice.status == 'draft'" type="button" mat-stroked-button color="warn" (click)="cancelConfirmDialog()">Cancel</button>
        <button *ngIf="isFormDisabled" type="button" mat-flat-button color="primary" (click)="create()">
          <mat-icon>add</mat-icon> Create
        </button>
        <button *ngIf="!isFormDisabled" type="button" mat-stroked-button (click)="discardChanges()">Discard</button>
      </ng-container>
    </div>
  </div>
  <div class="form-card">
    <fieldset [disabled]="isFormDisabled">
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Proforma No</mat-label>
            <input #invoice_no="ngModel" [disabled]="true" type="text" matInput name="invoice_number" [(ngModel)]="invoice.invoice_no">
            <mat-error *ngIf="invoice_no.invalid && invoice_no.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Proforma Date</mat-label>
            <input #date="ngModel" matInput [(ngModel)]="invoice.invoice_date" name="job_date" [matDatepicker]="invoice_date" [min]="minDate" [max]="maxDate" required>
            <mat-datepicker-toggle matSuffix [for]="invoice_date">
              <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #invoice_date></mat-datepicker>
            <mat-error *ngIf="date.invalid && date.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Company</mat-label>
            <mat-select [disabled]="isFormDisabled" [(value)]="selectedCompany" (selectionChange)="onCompanyChange()">
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keyup)="onCompanyKey($event)" matInput name="company_list">
              <mat-option *ngFor="let company of filteredCompanies" [value]="company.id">{{ company.company_name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Doctor Name</mat-label>
            <mat-select #doctor_id (openedChange)="onDoctorScroll($event)" [disabled]="isFormDisabled || disableDoctorSelection" [(value)]="selectedDoctor" (selectionChange)="onDoctorChange()" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keydown)="$event.stopPropagation()" (keyup)="onDoctorKey($event)" matInput name="doctort_list">
              <mat-option *ngFor="let doctor of allDoctors" [value]="doctor.id">{{ doctor.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Select Challans</mat-label>
            <mat-chip-grid class="matChipClasscross" #chipList aria-label="Challan selection">
              <mat-chip-row class="matChipClass" *ngFor="let challan of selectedChallanChips" [removable]="removable" (removed)="remove(challan)">
                {{ challan }}
                <button matChipRemove *ngIf="removable"><mat-icon>cancel</mat-icon></button>
              </mat-chip-row>
              <input #chipInput onkeydown="return false;" [formControl]="challanCtrl" [matAutocomplete]="auto" [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="add($event)">
            </mat-chip-grid>
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
              <mat-option *ngFor="let challan of notInvoicedChallans" [value]="challan">{{ challan.challan_no }}</mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>

      <!-- Line Items Table -->
      <table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z2 mt-3">
        <ng-container matColumnDef="job_no">
          <th mat-header-cell *matHeaderCellDef>Job No.</th>
          <td mat-cell *matCellDef="let element">{{ element.job_no }}</td>
        </ng-container>
        <ng-container matColumnDef="product_name">
          <th mat-header-cell *matHeaderCellDef>Product Name</th>
          <td mat-cell *matCellDef="let element">{{ element.product_name }}</td>
        </ng-container>
        <ng-container matColumnDef="product_units">
          <th mat-header-cell *matHeaderCellDef>Unit</th>
          <td mat-cell *matCellDef="let element">{{ element.product_units }}</td>
        </ng-container>
        <ng-container matColumnDef="rate">
          <th mat-header-cell *matHeaderCellDef>Rate</th>
          <td mat-cell *matCellDef="let element">{{ element.rate | currency :'INR':'symbol':'1.2-2' }}</td>
        </ng-container>
        <ng-container matColumnDef="discount_percent">
          <th mat-header-cell *matHeaderCellDef>Discount (%)</th>
          <td mat-cell *matCellDef="let element; let index = index">
            <input name="discount_percent-{{index}}" [(ngModel)]="element.discount_percent" (focusout)="calculateTaxesAndTotals(invoice)" type="number" onkeyup="if(parseInt(this.value)>=100){ this.value =100; return false; }">
          </td>
        </ng-container>
        <ng-container matColumnDef="amount_total">
          <th class="text-right" mat-header-cell *matHeaderCellDef>Amount</th>
          <td class="text-right" mat-cell *matCellDef="let element">{{ element.amount_total | currency :'INR':'symbol':'1.2-2' }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <!-- Tax Totals -->
      <div class="row pt-4">
        <div class="col-sm-4"></div>
        <div class="col-sm-8">
          <div class="totals-card">
            <div class="totals-row"><span>Sub Total (&#8377;):</span><span>{{ invoice.total_amount | currency :'INR':'symbol':'1.2-2' }}</span></div>
            <div class="totals-row">
              <span>Discount (&#8377;):</span>
              <span><input class="totals-input" [(ngModel)]="invoice.discount_amount" name="discount_amount" type="number" (change)="calculateTaxesAndTotals(invoice)" (focusout)="calculateTaxesAndTotals(invoice)"></span>
            </div>
            <div class="totals-row"><span>SGST (&#8377;):</span><span>{{ invoice.sgst_amount | currency :'INR':'symbol':'1.2-2' }}</span></div>
            <div class="totals-row"><span>CGST (&#8377;):</span><span>{{ invoice.cgst_amount | currency :'INR':'symbol':'1.2-2' }}</span></div>
            <div class="totals-row"><span>IGST (&#8377;):</span><span>{{ invoice.igst_amount | currency :'INR':'symbol':'1.2-2' }}</span></div>
            <div class="totals-row totals-grand"><span>Grand Total (&#8377;):</span><span>{{ invoice.grand_total | currency :'INR':'symbol':'1.2-2' }}</span></div>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
  <app-audit-log-viewer model="invoice" [recordId]="invoice.id"></app-audit-log-viewer>
</form>
